import { useContext } from "react";

import { useMutation } from "hooks";
import { createResolverFactory } from "components/QueryClient/ResolverFactory";

import toGlobalId from "scenes/Hubly/components/Workspace/api/helper";
import { ToasterContext } from "scenes/Hubly/components/Workspace/Provider";

const mutationFactory = () => {
  const query = `mutation assignNextWorkflowToConditionsGroup($nextWorkflowId: ID!, $conditionsGroupId: ID!) {
      assignNextWorkflowToConditionsGroup(nextWorkflowId: $nextWorkflowId, conditionsGroupId: $conditionsGroupId) {
        successMessage
      }
  }`;

  const resolver = ({ data: { assignNextWorkflowToConditionsGroup } }) => {
    return { data: assignNextWorkflowToConditionsGroup };
  };

  return { query: query, resolver: createResolverFactory(resolver) };
};

export function useAssignNextWorkflowToConditionsGroupAction() {
  const mutate = useMutation(mutationFactory);
  const { fireError } = useContext(ToasterContext);

  return (nextWorkflowId, conditionsGroupId) => {
    return mutate({
      nextWorkflowId: toGlobalId("NextWorkflow", nextWorkflowId),
      conditionsGroupId: conditionsGroupId,
    })
      .then((resp) => {
        return resp;
      })
      .catch((e) => {
        fireError(
          Array.isArray(e) && e[0]?.message
            ? e[0].message
            : "Failed to assign next workflow to conditions group, please retry or contact support for assistance",
          e
        );
      });
  };
}
export default useAssignNextWorkflowToConditionsGroupAction;
